<!--
 * @Author:
 * @LastEditTime: 2025-05-27 18:13:36
 * @Description: zhouhuan
-->
<template>
  <div
    class="position-absolute left-container"
    :style="{ height: height, top: top, width: '388px!important', overflow: `visible !important` }"
  >
    <el-row
      type="flex"
      align="middle"
      class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    >
      <el-col :span="18" class="fz-14 m-t-10px m-b-5px">模型树</el-col>
      <el-col :span="1" :offset="5">
        <span class="iconfont icon-line-close" @click="closeComponents"></span>
      </el-col>
    </el-row>

    <div class="height-38 p-5px mt-10px">
      <el-input
        size="small"
        placeholder="请输入要过滤的设备"
        v-model="filterTreeKeyWords"
        @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
        clearable
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          class=""
          @click="filterModelTree(0, true, filterTreeKeyWords, 0)"
        ></el-button>
      </el-input>
    </div>
    <div
      class="w-full h-[calc(100%-70px)] overflow-hidden mt-10px"
      v-loading="!modelTreeProp.modelTreeLoadEnd"
    >
      <el-tree
        class="modelTree text-white"
        v-if="modelTreeVisbile && modelTreeProp.modelTreeLoadEnd"
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        :filter-node-method="filterNode"
        :default-checked-keys="modelTreeProp.defaultCheckedKey"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="clickModelTree"
        @check="checkModelTree"
        :render-content="renderContent"
        node-key="node"
        show-checkbox
      >
      </el-tree>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModelTree',
  props: {
    player: {
      type: Object,
      default: null,
    },
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
          loadModelStatus: false,
        }
      },
    },
    // 模型点选的节点node
    modelNode: {
      type: Object,
      default: () => {},
    },
    height: {
      type: String,
      default: '50rem',
    },
    top: {
      type: String,
      default: '6.6rem',
    },
  },
  watch: {
    modelNode: {
      handler(node) {
        if (node?.name) {
          if (!node.name.toLowerCase().startsWith('Unspecified'.toLowerCase())) {
            this.currentNodeName = node.name
            this.filterModelTree(0, true, node.name, 3)
          }
        }
      },
      immediate: true,
    },
    'modelTreeProp.currentNodeName': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.currentNodeName = val
          this.filterModelTree(0, true, val, 3)
        }
      },
    },
    'modelTreeProp.defaultCheckedKey': {
      deep: true,
      handler(val, oldVal) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      },
    },
    'modelTreeProp.loadModelStatus': {
      immediate: true,
      async handler(val) {
        if (val) {
          this.getModelTreeDatas()
        }
      },
    },
  },
  data() {
    return {
      firstOpen: true, // 首次打开
      hoveringNode: null,
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      defaultExpandedKeys: [], // 展开节点
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
    }
  },
  methods: {
    closeComponents() {
      this.$emit('closeComponents', 'ModelTree')
    },
    renderContent(h, { node, data, store }) {
      // 动态生成插槽内容
      return h(
        'div',
        {
          class: ['custom-tree-node', { 'virtural-node': data.isVirtual }],
          on: {
            mouseover: () => {
              this.hoveringNode = data.code
            },
            mouseleave: () => {
              this.hoveringNode = null
            },
          },
        },
        [
          h('span', { class: 'el-tree-node__label' }, node.label),
          data.isVirtual && this.hoveringNode === data.code
            ? h(
                'el-tooltip',
                {
                  props: {
                    content: '分页节点，无法操作',
                    placement: 'right',
                  },
                },
                [
                  h('i', {
                    class: 'el-icon-warning-outline',
                    style: {
                      color: '#ff4d4f',
                      marginLeft: '5px',
                      cursor: 'pointer',
                    },
                  }),
                ]
              )
            : null,
        ]
      )
    },
    // 模型树点击操作
    clickModelTree(data, node, doLocation) {
      if (data.isVirtual) {
        return
      }
      if (node && node.checked && doLocation) {
        this.$emit('doLocation', data, 'modelTree')
        this.multipleLocations(this.player, data)
        this.modelTreeProp.currentNodeItem = data && data.node ? data.node : 0 // 储存选中节点的item
      }
      this.locationNode(data.node)
    },
    async multipleLocations(player, data, isSelect = true, isLoadEngine) {
      // 高亮选中的模型
      if (isSelect) {
        const selectNodes = await this.player.Native.Node.getSeletedNodes()
        await this.player.Native.Node.unSelectNodes(selectNodes)
        this.player.Native.Node.selectNodes([data.node])
      }
      const calculateValue = (aabb) => {
        const minPoint = aabb[0]
        const maxPoint = aabb[1]

        const dx = maxPoint[0] - minPoint[0]
        const dy = maxPoint[1] - minPoint[1]
        const dz = maxPoint[2] - minPoint[2]

        const L = Math.sqrt(dx ** 2 + dy ** 2 + dz ** 2)
        const value = 0 + 6.5 / (1 + Math.log(L + 1))
        return value
      }
      const nodeInfo = await this.player.Native.Node.getProperty(data.node, ['aabb'])
      // 相机移动到包围盒位置这里通过对数平滑将大的包围盒拉近，小的包围盒拉远
      this.player.Native.Camera.moveToAabbWithDistance(
        nodeInfo.aabb,
        1,
        5,
        calculateValue(nodeInfo.aabb)
      )
    },
    // 模型树加载
    async loadNode(node, resolve) {
      let tempFilterKeys = _.filter(this.modelTreeProp.treeData, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.node
        })
        return resolve(this.modelTreeProp.treeData)
      }
      let res = []
      if (node.data.isVirtual) {
        res = node.data.childs
      } else {
        const result = await this.player.Native.Node.getProperty(node.data.node, ['children'])
        res = result?.children || []
      }
      if (res.length > 1000) {
        const shardingRes = []
        for (let i = 0; i < _.ceil(res.length / 1000); i += 1) {
          shardingRes.push({
            name: `第${i + 1}页`,
            checked: true,
            code: `${node.data.code}${i}`,
            node: `${node.data.node}${i}`,
            parentNode: node.data.node,
            visible: true,
            childs: res.slice(i * 1000, (i + 1) * 1000),
            isVirtual: true,
          })
        }
        res = shardingRes
      }
      const filterRes = _.filter(res, (el) => {
        return el?.name
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.node
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.name
        }),
        (res5) => {
          return res5.node
        }
      )
      // 查看当前节点是否没有在隐藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = (nodeObj) => {
        return (
          _.indexOf(
            _.map(_this.modelTreeProp.modelHideList, (res1) => {
              return res1.node
            }),
            nodeObj.data.node
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在隐藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在隐藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在隐藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在隐藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else if (_.some(filterRes, { checked: false })) {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          this.modelTreeProp.defaultCheckedKey = [
            ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
              return val !== node.data.node
            }),
            ...checkedKeys,
          ]
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.node) {
          if (el.node === this.currentNode.node) {
            this.locationNode(this.currentNode.node)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)
        setTimeout(() => {
          const node = document.getElementsByClassName('modelTree')[0]
          const currentNode = document.getElementsByClassName('is-current')[0]
          node.scrollTo({
            top: currentNode.offsetTop,
          })
        }, 600)
      })
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      const isChecked = _.includes(checkeds.checkedKeys, data.node)
      if (data.isVirtual) {
        this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
        // return
      }
      this.$emit('setModelVisible', 'checkModelTree', isChecked, [data.node], checkeds)
    },
    async filterModelTree(startNode, direction, KeyWords, type, doLocation = true) {
      // 过滤模型树
      // #######################
      const res = await this.player.Native.Node.findNode(startNode, {
        names: [KeyWords],
        codes: [KeyWords],
      })
      this.currentNode = res.codes
        ? res.codes[KeyWords] || {}
        : res.names
        ? res.names[KeyWords] || {}
        : {}
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode, doLocation)
      } else {
        // 未找到
        this.$message({
          showClose: true,
          message: '搜索结果到底了',
          type: 'error',
        })
      }
    },
    // 展开节点树
    async expendNode(node, doLocation) {
      const rootNode = await this.player.Native.Node.getRoot()
      const rootChild = await this.player.Native.Node.getProperty(rootNode, ['children'])
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      if (node.node === rootChild.children[0]?.node) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          if (!this.currentNodeName) {
            // 无激活节点时
            this.clickModelTree(this.currentNode, { checked: true }, doLocation)
          }
          // 有选中激活节点时
          this.currentNodeName = ''
          this.locationNode(this.currentNode.node)
        })
      } else {
        const res = await this.player.Native.Node.getProperty(node.node, ['parent'])
        const currentLevelNodes = await this.player.Native.Node.getProperty(res.parent, [
          'children',
        ])
        const parentInfo = await this.player.Native.Node.getProperty(res.parent, ['code', 'name'])
        let expandIndex = null
        if (currentLevelNodes.children?.length > 1000) {
          expandIndex = _.findIndex(currentLevelNodes.children, ['node', node.node])
        }
        await this.expendNode(parentInfo, doLocation)
        if (!this.defaultExpandedKeys.includes(parentInfo.node)) {
          // 展开
          this.defaultExpandedKeys.push(parentInfo.node)
        }
        if (!_.isNil(expandIndex) && expandIndex > -1) {
          this.defaultExpandedKeys.push(
            `${parentInfo.node}${
              expandIndex % 1000 === 0 ? expandIndex / 1000 : _.ceil(expandIndex / 1000) - 1
            }`
          )
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      const rootNode = await this.player.Native.Node.getRoot()
      const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
      this.modelTreeProp.treeData = currentProperty.children
      this.modelTreeProp.modelTreeLoadEnd = true
    },
  },
}
</script>

<style lang="scss" scoped>

@import '../css/component.scss';

/deep/.el-card {
  &__header {
    background: none !important;
  }
  &__body {
    padding: 0 !important;
    height: calc(100% - 25px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}
::-webkit-scrollbar {
  width: 8px;
  background-color: rgba(53, 52, 52, 0);
}
::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: #2b323a;
}
/deep/ .el-loading-mask {
  height: calc(100% - 42px);
  background-color: rgba(24, 41, 72, 0.8) !important;
}
.text-color-white {
  color: white;
}
/deep/ .el-input-group__append button.el-button {
  padding-left: 15px;
  padding-right: 15px;
  background: transparent !important;
  color: white !important;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px !important;
}
/deep/ .el-input-group__append {
  padding: 0;
}
/deep/ .el-checkbox {
  margin-bottom: 0 !important;
}
.height-38 {
  height: 38px;
}
/deep/ .el-tree-node__label {
  color: white;
}
.header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.p-l-10px {
  padding-left: 10px;
}
.p-r-10px {
  padding-right: 10px;
}
.fz-14px {
  font-size: 14px;
}
.fz-12px {
  font-size: 12px;
}

</style>